module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-8.webp?4dcd3f5c";